import React from 'react'
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";
import CommonHomePageContent from "src/pages/HomePageContent/Common";
import System from "../../helper/system";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/support/Helper';
import AxiosIndicatorRunTimeLoader from '../AxiosIndicatorRunTimeLoader';

const Events = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { eventsList, searchText, apiCall } = props;

    const typeHeadSearchEvent = (obj) => {
        HelperAnalyticsEvent.typeHeadSearchEvent(searchText, "Events", obj?.name, obj?.url ? System.getRedirectionURL(obj.url.replace(/^.*\/\/[^\/]+/, '')) : obj.url);
    }
    return (
        <>
            <div className="search-item-title text-uppercase">RECOMMENDED Events</div>
            {__check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL']).status && !apiCall.Event ?
                <AxiosIndicatorRunTimeLoader />
                : <>
                    {Object.keys(eventsList).length > 0 ?
                        <>
                            <div className="search-artical-list">
                                {Object.keys(eventsList).length > 0 && Object.entries(eventsList).map((v, i) => (
                                    <React.Fragment key={i}>
                                        {i < 5 &&
                                            // <a href={v[1].url.replace('https://onesite-uat5.avnet.com:443', '')} className="search-artical-list-item cursor-pointer">
                                            <a href={v[1].url ? System.getRedirectionURL(v[1].url.replace(/^.*\/\/[^\/]+/, '')) : v[1].url} onClick={() => typeHeadSearchEvent(v[1])} className="search-artical-list-item cursor-pointer">
                                                <div className="search-artical-list-item-info">
                                                    <div className="search-artical-title">{v[1].name}</div>
                                                    <div className="search-artical-desc">
                                                        <div className='ellipses'>
                                                            {v[1].shortDescription}
                                                        </div>
                                                    </div>
                                                    <div className="date-location-box">
                                                        <div className="date-location-item">
                                                            <b>Date:&nbsp;</b> {Helper.getLongDateFormat(v[1].avnDate)}
                                                        </div>
                                                        <div className="date-location-item">
                                                            <b>Location:&nbsp;</b> {v[1].avnLocation}
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        }
                                    </React.Fragment>
                                ))}
                            </div>
                            <a href={HomePage.makeHomeTabsListRouteURL(CommonHomePageContent.chain_HomeTabList.CNT.param_value) + '&__c_HomePageContent=ALCT&__c_HomePageContentTabList=EVT&search=' + searchText + '&viewAll=true'}
                                className="text-center mt-auto pb-3 pt-3">
                                <div className="bs5 btn btn-sm btn-primary">VIEW ALL Event Results</div>
                            </a>
                        </>
                        : <NoContent />
                    }

                </>}
        </>
    )
}

export default Events